<template>
    <div class="view--sign-main">

        <div class="columns">
            <div class="column">
                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p style="padding: 14px">Category Info</p></div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label"></label>
                    </div>
                    <div class="field-body">
                        <article class="message is-light is-link">
                            <div v-for="(value,index) in CategoryInfos" :key="index" class="message-body is-success">
                                {{value}}
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>

        <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>View and Sign Pre Flight</p></div>
        <div class="notification is-info is-light">
            By signing this pre-flight report the Commander is signing the OFP according to OM-A 8.1.10, certifying that the pre-flight
            inspection has been done according to OM-A section 8, that the previous airplane technical log was reviewed and that the required briefings / training
            for the appropriate aerodromes has been performed.
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Signature</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <img :src="getSvgSignatureUrl" @error="errorSignatureShow(0)" @load="errorSignatureShow(1)" onerror="this.style.display='none'" width="300px" height="200px" alt="">
                    </div>
                    <div v-if="!SignatureShow">
                        <p>Signature couldn't get.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">PIC Sign</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input" type="text" placeholder="Username"  v-if="InputsObject.BTO.pic" v-model="InputsObject.BTO.pic" readonly>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Password</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input" type="text" placeholder="********" disabled>
                    </div>
                </div>
            </div>
        </div>
        <br>
    </div>
</template>

<script>

    import {loadingMixin} from "../../../utils/mixins";
    import {mapState} from "vuex";
    import {createUrl} from "../../../http";

    export default {
        name: "ViewandSign",
        props: ["id", "flight"],
        mixins: [loadingMixin],
        data() {
            return {
                OFPdata :"",
                CategoryInfos : [],
                getSvgSignatureUrl : "",
                activeSvgUrl : createUrl('/EffIpadPreview/GetInputSVG/'),
                SignatureShow:true,
            }
        },
        computed : {

            ...mapState("ipadmain",[ "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

            // ...mapState("viewandsign",["OFPjsonData"]),

            OfpData:function(){
                return this.EFF_Json_Data.poOFP;
            },

        },
        created()
        {
                this.getCategoryInfo();
                this.getSvgSignatureUrl = this.activeSvgUrl + this.id + "/" + this.flight.std + "/" + "BTO_Signature.svg"+"/"+this.flight.flightArchiveStat;
        },

        methods: {
            errorSignatureShow(stat)
            {
                if (stat ==0)
                {
                    this.SignatureShow = false;
                }
                else if(stat ==1)
                {
                    this.SignatureShow = true;
                }
            },

            getCategoryInfo()
            {
                        (this.EFF_Json_Data.poOFP.Dep_Cat == "")? "": this.CategoryInfos.push("Dep: "+this.EFF_Json_Data.poZipMain.Dep+" Airport Category is  "+this.EFF_Json_Data.poOFP.Dep_Cat);
                        (this.EFF_Json_Data.poOFP.Arr_Cat == "")? "": this.CategoryInfos.push("Dest: "+this.EFF_Json_Data.poZipMain.Arr+" Airport Category is  "+this.EFF_Json_Data.poOFP.Arr_Cat);
                        (this.EFF_Json_Data.poOFP.Alt1_Cat == "")? "": this.CategoryInfos.push("Dest Alt: "+this.EFF_Json_Data.poOFP.ARR_alt1+" Airport Category is  "+this.EFF_Json_Data.poOFP.Alt1_Cat);
                        (this.EFF_Json_Data.poOFP.Alt2_Cat == "")? "": this.CategoryInfos.push("Dest Alt2: "+this.EFF_Json_Data.poOFP.ARR_alt2+" Airport Category is  "+this.EFF_Json_Data.poOFP.Alt2_Cat);
                        (this.EFF_Json_Data.poOFP.DepAlt_Cat == "")? "": this.CategoryInfos.push("Dep Alt: "+this.EFF_Json_Data.poOFP.DEP_alt+" Airport Category is  "+this.EFF_Json_Data.poOFP.DepAlt_Cat);
                        (this.EFF_Json_Data.poOFP.Enroute_Cat == "")? "": this.CategoryInfos.push("Enroute: "+this.EFF_Json_Data.poOFP.Enroute+" Airport Category is  "+this.EFF_Json_Data.poOFP.Enroute_Cat);
            },
        }
    }
</script>

<style scoped>
    label {
        width: 150px;
    }
</style>
